import * as React from 'react';
import { useEffect } from 'react';

import { Banner, Text } from '@freenow/wave';

import { Level } from '../..';
import { Notification } from '../../types/Notification';

const ANIMATION_DURATION = 200;

const determineVariant = (level: Level) => {
    switch (level) {
        case Level.SUCCESS:
            return 'success';
        case Level.ERROR:
            return 'danger';
        default:
            // tslint:disable-next-line:no-console
            console.warn(`NotificationBanner background color cannot be determined for level: ${level}.`);
            return 'info';
    }
};

const BannerContent = ({ dismiss, notification }: { dismiss: () => void; notification: Notification }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            dismiss();
        }, notification.duration - ANIMATION_DURATION);

        return () => clearTimeout(timer);
    }, []);

    if (typeof notification.content === 'string') {
        return (
            <Text as="p" textAlign="center" fontWeight="semibold">
                {notification.content}
            </Text>
        );
    }

    return <>{notification.content}</>;
};

export const NotificationBanner = ({ notification }: { notification: Notification }) => {
    return (
        <Banner variant={determineVariant(notification.level)} position="top">
            {(dismiss) => <BannerContent dismiss={dismiss} notification={notification} />}
        </Banner>
    );
};
